module.exports = __webpack_public_path__ + "img/product_chart_4.0c22dc4b.png";